import { SerializedGraphsMap, SerializedRoutingGraph } from "../types/cache";

/**
 * SerializedGraphsMapの構造チェックを行う型ガード関数
 * @param obj
 * @returns
 */
export function isSerializedGraphsMap(obj: unknown): obj is SerializedGraphsMap {
  // 1. ルートがオブジェクトであることを確認
  if (typeof obj !== "object" || obj === null) {
    return false;
  }

  // 2. Mapのエントリ（キー）をチェック
  for (const graphKey in obj as Record<string, unknown>) {
    if (!Object.prototype.hasOwnProperty.call(obj, graphKey)) continue;

    const graphValue = (obj as Record<string, unknown>)[graphKey];

    // 3. 各グラフ値のルートプロパティを確認
    if (typeof graphValue !== "object" || graphValue === null) return false;

    // 4. 必須プロパティの存在と型をチェック
    const requiredProps = graphValue as Partial<SerializedRoutingGraph>;

    if (
      typeof requiredProps.floorId !== "string" ||
      !Array.isArray(requiredProps.nodes) ||
      !Array.isArray(requiredProps.edges)
    ) {
      return false;
    }

    // 5. nodes/edges 配列の構造（配列の配列）を簡易的にチェック
    // nodes配列の最初の要素が [string, object] の形式であることを確認
    if (
      requiredProps.nodes.length > 0 &&
      (!Array.isArray(requiredProps.nodes[0]) ||
        typeof requiredProps.nodes[0][0] !== "string" ||
        typeof requiredProps.nodes[0][1] !== "object")
    ) {
      return false;
    }

    // edges配列の構造のチェック
    if (
      requiredProps.edges.length > 0 &&
      (!Array.isArray(requiredProps.edges[0]) ||
        typeof requiredProps.edges[0][0] !== "string" ||
        !Array.isArray(requiredProps.edges[0][1]))
    ) {
      return false;
    }
  }

  return true;
}
